import React from "react";
import { ContactSidePanel } from "./ContactSidePanel";
import { useContacts } from "utilities/api/contactQuery";

interface SidePanelContactListProps {
  contacts: server.dto.ContactSmallV2[]
}

export const SidePanelContactList = (props: SidePanelContactListProps) => {
  const contacts = useContacts(props.contacts);

  return <>
    {contacts.map((contact, index) => <React.Fragment key={contact.contactId}>
      <ContactSidePanel
        contactId={contact.contactId}
        trigger={<a>{contact.name.fullName}</a>}
        fallbackIfNoPermission={<>{contact.name.fullName}</>}
      />
      {index !== contacts.length - 1 && <>, </>}
    </React.Fragment>)}
  </>
}